var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Warning: Content Exists ")]
          ),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pb-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "mb-0"
                        },
                        [
                          _vm._v(
                            " Content currently exists on your domain " +
                              _vm._s(_vm.softdomain) +
                              ". You must first uninstall it before proceeding with a new installation. "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "px-5 pt-0 pb-3 justify-content-end"
            },
            [
              _c(
                "gg-btn",
                {
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Understand")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }